import Navbar from '@/components/LandingPage/Navbar';
import Hero from '@/components/LandingPage/Hero';
import StatsBar from '@/components/LandingPage/StatsBar';
import Plans from '@/components/LandingPage/Plans';
import StakeCalculator from '@/components/LandingPage/StakeCalculator';
import HowItWorks from '@/components/LandingPage/HowItWorks';
import Referral from '@/components/LandingPage/Referral';
import StopLoss from '@/components/LandingPage/StopLoss';
import FAQ from '@/components/LandingPage/FAQ';
import Testimonials from '@/components/LandingPage/Testimonials';
import CTABanner from '@/components/LandingPage/CTABanner';
import Footer from '@/components/LandingPage/Footer';
import ContactUs from '@/components/LandingPage/ContactUs';

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="pb-8 sm:pb-12">
        <Hero />
        <StatsBar />
        <Plans />
        <StakeCalculator />
        <HowItWorks />
        <Referral />
        <StopLoss />
        <FAQ />
        <Testimonials />
        <ContactUs />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}
